<template>
  <RevContainer class="mt-8 md:mt-7">
    <div id="form" class="h-[80vh]" />
  </RevContainer>
</template>

<script setup lang="ts">
import { useHead, useRoute } from '#imports'
import { onMounted } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContainer } from '@ds/components/Container'
// Typeform's sdk: https://developer.typeform.com/embed/vanilla
import { createWidget } from '@typeform/embed'
import '@typeform/embed/build/css/widget.css'

import { useSellerInfoStore } from '~/scopes/auth/stores/sellerInfoStore'

import translations from './Feedback.translations'

const i18n = useI18n()
const route = useRoute()

const { companyName, countryOfOrigin, email, id } = useSellerInfoStore()

const formId = String(route.query.formId || '')
const fromPath = String(route.query.fromPath || '')

useHead({
  title: i18n(translations.metaTitle),
  meta: [
    {
      name: 'description',
      content: i18n(translations.metaDescription),
    },
  ],
})

onMounted(() => {
  createWidget(formId, {
    container: document.querySelector('#form') as HTMLElement,
    hidden: {
      company: companyName || '',
      country: countryOfOrigin || '',
      email: email || '',
      fromPath,
      hostname: window.location.hostname,
      id: id?.toString() || '',
    },
  })
})
</script>
